import {
	DISABLED_STATUSES_EMPLOYEE,
	DISABLED_STATUSES_IPA,
	FLOW_TYPE,
	MIFID_STATUS,
	PROCESS_STATUS,
	RENEW_PREFIX
} from 'consts';
import type { EntityProcessInfo, UserRelations } from 'types';

export function findSelected(data: UserRelations, ssn: string) {
	return [...data.children, ...data.companies, data.person].find(x => ssn === x.kennitala);
}

export function decorateUserRelations(
	data: UserRelations,
	flowType: string,
	mifidStatus: number,
	isEmployeeWeb: boolean
): UserRelations {
	const children = decorateItem(data.children || [], flowType, mifidStatus, isEmployeeWeb);
	const companies = decorateItem(data.companies, flowType, mifidStatus, isEmployeeWeb);
	const person = decorateItem([data.person], flowType, mifidStatus, isEmployeeWeb)[0];
	return { children, companies, person };
}

function decorateItem(
	items: EntityProcessInfo[],
	flowType: string,
	mifidStatus: number,
	isEmployeeWeb: boolean
): EntityProcessInfo[] {
	if (flowType.startsWith(RENEW_PREFIX)) {
		return items.map(item => ({ ...item, disabledCard: false, disabledButton: false }));
	}
	if (FLOW_TYPE.ES_MV === flowType) {
		const unfinishedMifid = MIFID_STATUS.HasNotFinishedMifid === mifidStatus;
		return items.map(item => {
			const disabledCard =
				unfinishedMifid ||
				(item.processInfo ? item.processInfo.processStatus >= PROCESS_STATUS.InSigning : false);
			const disabledButton = PROCESS_STATUS.InSigning !== item.processInfo?.processStatus;
			return { ...item, disabledCard, disabledButton };
		});
	}
	const statuses = isEmployeeWeb ? DISABLED_STATUSES_EMPLOYEE : DISABLED_STATUSES_IPA;
	return items.map(item => {
		const disabledCard = item.processInfo ? item.processInfo.processStatus in statuses : false;
		const disabledButton = PROCESS_STATUS.InSigning !== item.processInfo?.processStatus;
		return { ...item, disabledCard, disabledButton };
	});
}
